<template>
    <div class="back" @click="$router.go(-1)">
        <img src="/assets/img/icon-arrow-left.svg" />
    </div>
</template>

<script>
    export default {
        name: "GoBack"
    }
</script>